// Chain IDs
export const LOCALHOST_CHAIN_ID = 31337;
export const LOCALHOST_RIVER_CHAIN_ID = 31338;
export const BASE_MAINNET = 8453;
export const BASE_SEPOLIA = 84532;
export const RIVER_CHAIN_ID = 6524490;
//# sourceMappingURL=Web3Constants.js.map